import React, { useCallback, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import actions from "../../actions";
import { getParticularDateAiChat, getUserChats } from "../../apis";
import "./AiChat.css";
import AiChatHistoryTable from "./AiChatHistoryTable";
import { IoMdArrowRoundBack } from "react-icons/io";

const ChatHistory = ({ startLoadingRequest, stopLoadingRequest,date }) => {
  const { id } = useParams();
  const [chatMessages, setChatMessages] = useState([]); // Store chat messages
  const [isback,setIsBack]=useState(false)

  // Fetch user chat data
  const fetchUserChats = useCallback(async () => {
    try {
      const apiResponse = await getParticularDateAiChat(id, date);
      console.log("bot_chat", apiResponse?.data?.data)
      if (apiResponse?.data?.data) {
        setChatMessages(apiResponse?.data?.data); // Set chat messages from response
      }
    } catch (error) {
      console.error("Error fetching chat messages", error);
    }
  }, [id]);

  useEffect(() => {
    stopLoadingRequest();
    fetchUserChats();
  }, [fetchUserChats, stopLoadingRequest]);

  if(isback){
    return <AiChatHistoryTable/>;
  }

  return (
    <>
      <div className="chat-container">
       
        <div
          className="group-header"
          style={{
            textAlign: "center",
            backgroundColor: "black",
            color: "white",
            padding: "5px 10px",
            margin: "10px auto",
            borderRadius: "4px",
            width: "fit-content",

          }}
        >
          {new Date(date).toLocaleDateString()}
        </div>
        <IoMdArrowRoundBack onClick={() => setIsBack(true)} className="z-10" style={{ cursor: "pointer",position:"absolute" }} />
        <div className="chat-history">
          {chatMessages.length > 0 ? (
            chatMessages.map((message, index) => (
              <>
                
                <div
                  key={message._id}
                  className={`chat-message ${message.senderId === id ? "sent" : "received"
                    }`}
                >

                  <p>{message.message}</p>
                  {message.options.length > 0 && (
                    <div className="message-options">
                      {message.options.map((option, idx) => (
                        <button key={idx} className="option-button">
                          {option}
                        </button>
                      ))}
                    </div>
                  )}
                  {message.media.length > 0 && (
                    <div className="message-media">
                      {message.media.map((mediaUrl, idx) => (
                        <img key={idx} src={mediaUrl} alt="media" />
                      ))}
                    </div>
                  )}
                  <small className="timestamp">
                    {new Date(date).toLocaleString()}
                  </small>
                </div>

                {/* <div
                  className={`chat-message_name ${message.senderId === id ? "sent" : "received"
                    }`}
                >🤓</div> */}
              </>


            ))
          ) : (
            <p>No chat history available</p>
          )}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
      deactivateSidebarRequest: actions.sidebar.deactivateSidebar,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(ChatHistory);
